import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen grid place-items-center bg-forest text-cream p-8 text-center">
          <div>
            <h1 className="font-display text-4xl uppercase font-bold">Something threw a rod</h1>
            <p className="mt-3 text-cream/60">This page hit an unexpected error. Please reload to get back on the road.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
